import currency from '@/filters/currency';

function calculateTax(subtotal, taxPercentage) {
	if (subtotal === 0) {
		return null;
	}
    
	const percentage = (taxPercentage/100),
		tax = Math.round(percentage * subtotal),
		total = tax + subtotal;
    
	return {
		subtotal: currency(subtotal, true),
		tax: currency(tax, true),
		total: currency(total, true)
	};
}

export default {
	calculateTax
};



// WEBPACK FOOTER //
// ./src/modules/tax-util.js